<template>
  <div id="contents">
    <div class="recruit_pinch" v-if="pinch_post">
      <div class="recruit_pinch_main" :class="[pinch_post.style_name]">
        <div class="title_area">
          <p class="title">入社史上最大のピンチ</p>
          <p class="title small">〜こうやって乗り越えた〜</p>
        </div>
        <div @click="close" class="back_btn_icon">
          <img src="../assets/img/common/recruit_2021/close.png" alt="close">
        </div>
        <p class="caption">{{ pinch_post.caption }}</p>
        <div class="main_image">
          <p class="img"><img :src="pinch_post.main_img" alt="" /></p>
          <div class="profile">
            <p class="name_jp">{{ pinch_post.name_jp }}<span class="name_en">{{ pinch_post.name_en }}</span></p>
            <p class="desc" v-html="pinch_post.desc"></p>
          </div>
        </div>
        <div class="article_wrap miyazawa_bg">
          <div class="article" v-for="article in pinch_post.article" :key="article.id">
            <div class="title" v-for="title in article.title" :key="title.id">
              <p>{{ title.text }}</p>
            </div>
            <div class="content" v-for="content in article.content" :key="content.id">
              <p class="text" v-html="content.text"></p>
              <p class="img" :class="content.img_class" v-if="content.img_flg"><img :src="content.img_url" alt=""></p>
            </div>
          </div>
        </div>
      </div>
      <div class="footer"></div>
    </div>
  </div><!-- #contents -->
</template>
<script>
import pinch_post_list from './js/recruit_pinch.json'
export default {
  name: 'recruit_pinch',
  data() {
    return {
      pinch_post_list: pinch_post_list,
      pinch_post: null,
      request_id: this.$route.params.id,
      loading: false,
      post_list: null,
      error: null,
    }
  },
  props: [
    'post_type'
  ],
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
    this.fetch_pinch_post(this.$route.params.id)
  },
  methods: {
    fetch_pinch_post(request_id){
      this.pinch_post = this.pinch_post_list[request_id]
      if (this.post_type != 'all'){
        setTimeout(() => {
          if (this.link){
            var speed = 1500;
            var href = this.link
            var target = $('#' + href)
            var position = target.offset().top - 50;
            $('body,html').animate({scrollTop:position}, speed, 'swing');
            return false;
          }
        }, 300);
      }
    },
    reload_model(post_id, layout) {
      var post = this.young_post_list.find(post => post.id == post_id);
      if (post != null){
        this.$emit('reload_model', post_id, layout);
      }
    },
    close(){
      this.$emit('close_icon');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  #contents
    width: 100vw
  .recruit_pinch
    &_main
      width: 90.4vw
      margin: calc(36.1vw - 41px) auto 0
      padding: 44px 0 30px
      background-color: #fff
      position: relative
      &.miyazawa
        .title
          background: #FFA700
        .article_wrap
          background-image: url("../assets/img/common/recruit_2022/pinch/miyazawa_bg.png")
      &.miura
        .title
          background: #FF7689
        .main_image
          .img
            padding: 0 11px 0 6px
          .profile
            .name_jp
              background: #FF7689
            .name_en
              background: #FF7689
        .article_wrap
          background-image: url("../assets/img/common/recruit_2022/pinch/miura_bg.png")
          .article
            .title
              p
                background: #FF7689
      &.nakazawa
        .title
          background: #FFEF76
        .main_image
          .img
            padding: 0 11px 0 6px
          .profile
            .name_jp
              background: #FFEF76
            .name_en
              background: #FFEF76
        .article_wrap
          background-image: url("../assets/img/common/recruit_2022/pinch/nakazawa_bg.png")
          background-position: center 20px
          .article
            .title
              p
                background: #FFEF76
      &.takagi
        .title
          background: #A5FF76
        .main_image
          .img
            padding: 0 11px 0 6px
          .profile
            .name_jp
              background: #A5FF76
            .name_en
              background: #A5FF76
        .article_wrap
          background-image: url("../assets/img/common/recruit_2023/pinch/takagi_bg.png")
          background-position: center 20px
          .article
            .title
              p
                background: #A5FF76
      &.hosoda
        .title
          background: #54D163
        .main_image
          .img
            padding: 0 11px 0 6px
          .profile
            .name_jp
              background: #54D163
            .name_en
              background: #54D163
        .article_wrap
          background-image: url("../assets/img/common/recruit_2024/pinch/hosoda_bg.png")
          background-position: center -9px
          .article
            .title
              p
                padding: 1px 7px 3px 5px
                background: #54D163
      .title_area
        position: absolute
        top: -25px
        left: 21px
        .title
          @include recruit_font(24px, 43px, .176em)
          color: #003A6F
          padding: 0 3px 0 9px
          display: table
        .small
          @include recruit_font(16px, 1em, .176em)
          padding: 0 3px 7px 9px
      .caption
        @include recruit_font(12px, 23px, 1.5px)
        color: #003A6F
        display: block
        margin: 20px auto 20px
        padding: 0 20px
      .back_btn_icon
        position: absolute
        top: -78px
        left: 0vw
        img
          width: 32px
          height: 32px
      .main_image
        margin: 0px auto 25px
        padding: 0 21px
        .img
          img
            width: 100%
      .profile
        margin: 25px 0 0
        .name_jp
          @include recruit_font(24px, 27px, .176em)
          display: inline-flex
          padding: 0 0 1px 7px
          background: #FFA700
          color: #003A6F
        .name_en
          @include recruit_font(14px, 28px, .05em)
          padding: 0 10px 0 7px
          background: #FFA700
          color: #003A6F
        .desc
          @include recruit_font(10px, 1.7em, .05em)
          transform: scale(0.9)
          transform-origin: left top
          width: 113%
          margin: 8px 0 0
          color: #003A6F
      .article_wrap
        background-image: url("../assets/img/common/recruit_2022/pinch/miyazawa_bg.png")
        background-repeat: no-repeat
        background-size: contain
        background-position: center
        .article
          position: relative
          padding: 0 0 37px
          &:last-child
            padding: 0
          .title
            padding: 0 0 0 21px
            background: unset
            p
              @include recruit_font(26px, 1.4em, 0em)
              display: inline
              padding: 0 11px 0 5px
              font-feature-settings: "palt" 1
              background: #FFA700
              color: #003A6F
          .content
            margin: 15px 0 0
            padding: 0 21px
            &:first-child
              margin: 0
            .text
              @include recruit_font(12px, 1.9em, 0.11em)
              width: 100%
              color: #003A6F
            .img
              img
                width: 100%
            .miyazawa_01_00
              width: 175px
              margin: 30px auto 32px
            .hosoda_02_00
              width: 270px
              margin: 17px auto 13px
    .footer
      padding-bottom: 70px
  @media screen and (max-width: 374px)
    .recruit_pinch
      &_main
        .back_btn_icon
          top: -69px
        .title_area
          top: -18px
          .title
            @include recruit_font(20px, 34px, .176em)
          .small
            @include recruit_font(12px, 1em, .176em)
        .caption
          margin: 11px auto 20px
        .profile
          .name_jp
            @include recruit_font(20px, 27px, .176em)
        .article_wrap
          .article
            .title
              p
                @include recruit_font(21px, 1.3em, 0em)
</style>



// WEBPACK FOOTER //
// src/components/recruit_pinch.vue